import { ListBuilder, Pagination, TileGrid } from "@redriver/cinnamon";
import React from "react";
import { getBookingsList } from "./actions";
import BookingBlock from "./BookingBlock";
import { Button } from "semantic-ui-react";
import useSkiSeasonDates from "modules/useSkiSeasonDates";

const BookingsList = () => {
  const skiSeasonDates = useSkiSeasonDates();
  return (
    <ListBuilder
      withTiles
      loadAction={getBookingsList}
      loadParams={{
        from: skiSeasonDates.start.toISOString(),
        to: skiSeasonDates.end.toISOString(),
      }}
      initialPagination={{
        pageSize: 25,
        pageNumber: 1,
      }}
      totalTransform={(x) => x.totalResults}
      dataTransform={(x) => x.results}
      renderList={(tileProps, state, events) => (
        <div>
          <h2 style={{ padding: "0 6px" }}>Bookings</h2>
          {tileProps.data.length == 0 && <p>No bookings found.</p>}
          <TileGrid
            {...tileProps}
            dataKey="id"
            emptyMessage={false}
            className="bookings-list"
            render={(x) => <BookingBlock booking={x} key={x.id} />}
          />

          {state.hasMore && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                primary
                size="small"
                loading={state.loadingMore}
                onClick={events.onLoadMore}
              >
                Load More
              </Button>
            </div>
          )}
        </div>
      )}
    />
  );
};

export default BookingsList;
